export const API_HOST = process.env.REACT_APP_API_HOST;
export const WEB_HOST = process.env.REACT_APP_WEB_HOST;

export const CONSOLE_HOST = process.env.REACT_APP_CONSOLE_HOST;
export const AXIOS_DEFAULTS_TIMEOUT = process.env.REACT_APP_AXIOS_DEFAULTS_TIMEOUT;
export const LOCALE_STORAGE_KEY = 'locale';

export const freePlanId = process.env.REACT_APP_FREE_PLAN_ID
export const basicPlanId = process.env.REACT_APP_BASIC_PLAN_ID
export const proPlanId = process.env.REACT_APP_PRO_PLAN_ID
